import { UpgradeTutorialWhiteTextStyle } from "./UpgradeTutorialWhiteTextStyle";

export class UpgradeTutorialPurpleTextStyle extends UpgradeTutorialWhiteTextStyle {
    public constructor() {
        super();
        this.fill = [
            "#95229D",
            "#DD2FF0",
            "#EA84F7"
        ];
    }
}